import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from 'app/design-system/components/Modal';

import { fetchSearchedValue } from '../actions';
import SearchInput from '../Input';
import { useSearchParams } from '../useSearchParams';

import styles from './Modal.module.scss';

const SearchModal: FC = () => {
  const dispatch = useDispatch();
  const { removeSearchKey, timedSearchString, hasSearchKey } = useSearchParams();

  useEffect(() => {
    if (timedSearchString) {
      dispatch(fetchSearchedValue(timedSearchString));
    }
  }, [timedSearchString]);

  return (
    <Modal isOpen={hasSearchKey}
           onClose={removeSearchKey}
           maxWidth={755}
           className={styles.modal} >
      <SearchInput />
    </Modal>
  );
};

export default SearchModal;
